// Environment ID constants - change these values to update environment IDs globally
export const ENV_IDS = {
  SANDBOX: 1 as const,
  PRODUCTION: 6 as const
} as const;

// Type for environment IDs
export type EnvId = typeof ENV_IDS[keyof typeof ENV_IDS];

// Environment names
export const ENV_NAMES = {
  SANDBOX: 'sandbox' as const,
  PRODUCTION: 'production' as const
} as const;

// Type for environment names  
export type EnvironmentName = typeof ENV_NAMES[keyof typeof ENV_NAMES];